import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout";
import Login from "./pages/Login";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import Horses from "./pages/Horses";
import HorseProfile from "./pages/HorseProfile";
import Owners from "./pages/Owners";
import OwnerProfile from "./pages/OwnerProfile";
import Staff from "./pages/Staff";
import UserProfile from "./pages/UserProfile";
import SuperAdmin from "./pages/SuperAdmin";
import Settings from "./pages/Settings";
import Trips from "./pages/Trips";
import TripDetail from "./pages/TripDetail";
import Scheduler from "./pages/Scheduler";
import ChangePassword from "./pages/ChangePassword";
import Placeholder from "./pages/Placeholder";
import { Toaster } from "@/components/ui/sonner";

const RootRedirect = () => {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user) return <Navigate to="/onboarding" replace />;
  if (user.role === "super_admin" && !user.is_impersonating) {
    return <Navigate to="/admin" replace />;
  }
  return <Navigate to="/dashboard" replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/onboarding" element={<Onboarding />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <AppLayout><Dashboard /></AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/horses"
            element={
              <ProtectedRoute>
                <AppLayout><Horses /></AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/horses/:horseId"
            element={
              <ProtectedRoute>
                <AppLayout><HorseProfile /></AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/owners"
            element={
              <ProtectedRoute>
                <AppLayout><Owners /></AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/owners/:ownerId"
            element={
              <ProtectedRoute>
                <AppLayout><OwnerProfile /></AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AppLayout><SuperAdmin /></AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <AppLayout><Settings /></AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/staff"
            element={
              <ProtectedRoute>
                <AppLayout><Staff /></AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/staff/:userId"
            element={
              <ProtectedRoute>
                <AppLayout><UserProfile /></AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Placeholder title="Jobs" description="Transport jobs, vet appointments, daily tasks." testid="jobs-page" />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/change-password"
            element={
              <ProtectedRoute allowDuringPasswordReset>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
          <Route
            path="/trips"
            element={
              <ProtectedRoute>
                <AppLayout><Trips /></AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/trips/:tripId"
            element={
              <ProtectedRoute>
                <AppLayout><TripDetail /></AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/scheduler"
            element={
              <ProtectedRoute>
                <AppLayout><Scheduler /></AppLayout>
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
